<template>
    <div class="container is-fluid">
			  <div class="box" v-if="contacts.length > 0">	

				  <table class="table is-fullwidth" id="contacttable">
					  	<thead>
							  <tr>
								<th>Name</th>
								<th>Company</th>
								<th>Email</th>
								<th>Mobile</th>
								  </tr>
							  </thead>
							  <tbody>
								<tr valign="top"  v-for="row in contacts" v-cloak v-bind:key="row.id">
									<td ><router-link :to="{path: '/contacts/' + row.id}">{{row.forename}} {{row.surname}}</router-link></td>
									<td >{{row.company}}</td>
									<td ><a :href="'mailto:' + row.email" target="_blank">{{row.email}}</a></td>
									<td >{{row.mobile}}</td>
								</tr>
								  </tbody>
					  </table>


			  </div>

			  <div class="notification is-warning" v-if="contacts.length == 0">
				There are no contacts matching your search criteria
				</div>
				
			</div>

</template>

<script>
import XLSX from 'xlsx';

export default {
 props: ['contacts'],
 methods: {
	 exportXLS() {
		 //alert("hi")
		 var wb = XLSX.utils.table_to_book(document.getElementById('contacttable'), {sheet:"Sheet JS"});
		 XLSX.writeFile(wb, 'contacts.xlsx')

	 }
 }
}
</script>